'use client';

import { useRouter } from 'next/navigation';
import { useNavigationLoading } from '@/contexts/NavigationLoadingContext';

/**
 * Custom hook that wraps Next.js router with loading state
 * Usage: const router = useNavigationRouter();
 *        router.push('/path');
 */
export function useNavigationRouter() {
  const router = useRouter();
  const { setNavigating } = useNavigationLoading();

  return {
    push: (path: string) => {
      setNavigating(path);
      router.push(path);
    },
    replace: (path: string) => {
      setNavigating(path);
      router.replace(path);
    },
    back: () => {
      setNavigating('previous page');
      router.back();
    },
    forward: () => {
      setNavigating('next page');
      router.forward();
    },
    refresh: () => {
      router.refresh();
    },
    prefetch: (path: string) => {
      router.prefetch(path);
    },
  };
}
